jQuery(document).ready(function() {
    console.log("ready custom select!");
    jQuery(".custom-select .accordion-panel > div").click(function() {
        var selected = jQuery(this);
        var accordion = selected.closest(".accordion");
        var header = accordion.find(".label");
        // Update the title of the select element
        header.attr("label", selected.text());
        header.html(selected.text());
        if (!selected.hasClass("selected")) {
            selected.parent().find("div").removeClass("selected");
            selected.addClass("selected");
        }
        // close the accordion
        accordion.find(".accordion-trigger").trigger("click");
    });
});
